import keyBy from 'lodash/keyBy';

export const RGB_COLORS = {
  greenBackground: 'rgb(0, 171, 79)',
  greenText: 'rgb(255, 255, 255)',
  yellowBackground: 'rgb(255, 153, 41)',
  yellowText: 'rgb(255, 255, 255)',
  blueBackground: 'rgb(0, 189, 243)',
  blueText: 'rgb(255, 255, 255)'
};

export const TYPE_COLORS = [
  {
    key: 'gp',
    label: 'GP$',
    bgColor: 'rgb(255,105,180)',
    color: RGB_COLORS.greenText
  },
  {
    key: 'upt',
    label: 'UPT',
    bgColor: 'rgb(0, 189, 243)',
    color: RGB_COLORS.blueText
  },
  {
    key: 'hc',
    label: 'Hourly Customers',
    bgColor: 'rgb(255, 153, 41)',
    color: RGB_COLORS.yellowText
  }
];

export const TYPE_COLORS_BY_KEY = keyBy(TYPE_COLORS, 'key');

export const CHECKLIST = ['/promotions', '/wab', '/plan'];
